import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';

const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = { autoCapture: true };
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.VUE_APP_INSTRUMENTATION_KEY,
        enableAutoRouteTracking: true, // SAPでのルート変更を自動的に追跡
        enableRequestHeaderTracking: true, // AJAX と Fetch の要求ヘッダー追跡
        enableResponseHeaderTracking: true, // AJAX と Fetch の要求応答ヘッダー追跡
        disableFetchTracking: false, // フェッチ要求自動収集不可フラグ
        enableCorsCorrelation: true, // 送信される AJAX 依存関係がサーバー側の対応する要求との関連付け
        correlationHeaderExcludedDomains: [""], // 特定のドメインの関連付けヘッダーの無効
        // Web ページのクリック イベントが自動的に追跡され、HTML 要素の data-* 属性を使用してイベント テレメトリにデータを設定
        extensions: [clickPluginInstance],
        extensionConfig: {
            [clickPluginInstance.identifier]: clickPluginConfig
        },
    },
});
appInsights.loadAppInsights();
appInsights.trackPageView();

export function useAppInsights () {
    return appInsights
}